import { AxiosError, isAxiosError } from "axios";

import type {
  OfferIsNotAvailableAnymoreOutputDto,
  SearchResultsAreNotAvailableOutputDto,
} from "@/types/codegen";

export function isOfferIsNotAvailableAnymoreError(
  error: unknown,
): error is AxiosError<OfferIsNotAvailableAnymoreOutputDto> {
  return (
    isAxiosError<OfferIsNotAvailableAnymoreOutputDto>(error) &&
    !!error.response?.data &&
    typeof error.response?.data === "object" &&
    "code" in error.response.data &&
    error.response.data.code === "OFFER_IS_NOT_AVAILABLE_ANYMORE"
  );
}

export function isSearchExpiredError(
  error: unknown,
): error is AxiosError<SearchResultsAreNotAvailableOutputDto> {
  return (
    isAxiosError<SearchResultsAreNotAvailableOutputDto>(error) &&
    error.response?.data?.code === "SEARCH_RESULTS_ARE_NOT_AVAILABLE"
  );
}
